import { render, staticRenderFns } from "./PopUpSendIpoteka.vue?vue&type=template&id=4c97a9a2&scoped=true&"
import script from "./PopUpSendIpoteka.vue?vue&type=script&lang=js&"
export * from "./PopUpSendIpoteka.vue?vue&type=script&lang=js&"
import style0 from "./PopUpSendIpoteka.vue?vue&type=style&index=0&id=4c97a9a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c97a9a2",
  null
  
)

export default component.exports